import {
  ref,
  onMounted,
  onUnmounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
// import { formatTotal } from "@/utilities/display-helpers";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import { sellContractsController } from "@/controllers/sellContracts";

import { JSConn } from "@/utilities/js-conn";

import { ActiveNavMenuSetting } from "@/store/modules/session";

import { SellContract } from "@/models/SellContract";

export default defineComponent({
  name: "sellContractShow",
  components: {
    LoadingAnimation,
  },
  props: {
    sellContractId: {
      type: String,
      required: true,
    },
  },

  setup(props, ctx) {
    const $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage = "Please wait while the sell contract is loaded...";

    onMounted(() => {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: props.sellContractId,
      };

      Promise.all([sellContractsController.needSellContract(jsConn)])
        .then(() => {
          $store.dispatch(
            "updateActiveNavMenu",
            ActiveNavMenuSetting.sellContract,
          );
        })
        .finally(() => {
          dataLoaded.value = true;
        });
    });

    onUnmounted(() => {
      $store.dispatch("updateActiveNavMenu", ActiveNavMenuSetting.main);
    });

    const apiSellContract = computed(() => {
      return $store.getters.sellContract as SellContract;
    });

    return {
      apiSellContract,

      dataLoaded,
      loadingMessage,
    };
  },
});
